import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Component, Input } from '@angular/core';
import { NgbActiveModal }     from '@ng-bootstrap/ng-bootstrap';

import { ApiService } from '../../app-lite/api/api.service';

@Component({
  selector   : 'wor-add-dealerhip',
  template: require('./company.add-dealership.component.html')
})
export class AddDealershipComponent {
  @BlockUI('addDealershipBlock') block : NgBlockUI;

  @Input() quote : number;

  constructor (
    private activeModal: NgbActiveModal,
    private apiService : ApiService
  ) {}

  confirm () : void {
    this.block.start();

    this.apiService.get('/company/convert_to_dealership_from_workshop')
    .then(() => this.apiService.get('/company/add_dealership'))
    .then(( dealership ) => {
      this.activeModal.close(dealership);
    })
    .catch(( err ) => {
      this.activeModal.dismiss(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }
}
